module.exports = __webpack_public_path__ + "static/img/5.4862f9d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/eng/5.png
// module id = mEK+
// module chunks = 0